<template>
    <div class="flex-col justify-start relative page">
        <div class="flex-col justify-start items-center relative">
            <img class="imagebg" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imagesNew/bg1.png" />
            <img class="logo" src="@/assets/logo.png" alt="">
        </div>
        <div class="content">
            <div class="mian">
                <div class="wz">请输入您的手机号</div>
                <div class="inpm">
                    <input type="text" maxlength="11" v-model="mobile">
                </div>

                <div class="wz" style="margin-top: 30px;">请输入您的验证码</div>
                <div class="inpm">
                    <input type="text" maxlength="6" v-model="code">
                    <div class="yamanniu" @click="send" v-if="countDown === 0">发送验证码</div>
                    <div class="yamanniu" v-else>{{ countDown }}秒后重新发送</div>
                </div>
            </div>

            <div class="aniu" @click="submit">进入</div>
        </div>
    </div>
</template>
<script>
import { sendcode, pepolist, spacegetList } from "@/api/go";
export default {
    components: {},
    beforeRouteEnter(to, from, next) {
        let s = to.query.s;
        if (s) {
            if (s == 1) {
                next({
                    name: "index",
                    query: to.query
                });
            } else if (s == 2) {
                next({
                    name: "farewell",
                    query: to.query
                });
            } else if (s == 3) {
                next();
            }
        } else {
            next();
        }
    },
    data() {
        return {
            mobile: '',
            code: '',
            countDown: 0, // 倒计时初始值
        };
    },
    mounted() {
        // // 加载 Alicom 验证码脚本
        const script = document.createElement('script');
        script.src = 'https://shrine.oss-cn-chengdu.aliyuncs.com/static/js/ct4.js';
        script.onload = this.initCaptcha;
        document.body.appendChild(script);
    },
    computed: {

    },
    watch: {

    },
    methods: {
        initCaptcha() {
            // 初始化验证码
            window.initAlicom4({
                captchaId: "f206560ceccf53d914a530be12471ba2",
                product: 'bind',
                protocol: 'https://' //部署在对应服务上可删除此配置
            }, (captcha) => {
                this.captcha = captcha;
                captcha.onReady(() => {
                    // console.log("验证码已准备好");
                }).onSuccess(() => {
                    const result = captcha.getValidate();
                    if (!result) {
                        return alert('完成验证');
                    }
                    result.captcha_id = "f206560ceccf53d914a530be12471ba2";
                    // 在这里处理验证成功后的逻辑
                    // console.log('验证成功: ', result);
                    // 开始倒计时
                    this.startCountDown(result);
                }).onError(() => {
                    console.error('验证码验证失败');
                    // 在这里处理验证失败的逻辑
                });
            });
        },
        send() {
            // 使用正则表达式匹配中国大陆手机号
            const regex = /^1[3-9]\d{9}$/;
            if (!regex.test(this.mobile)) {
                this.$message('请输入正确的手机号！');
                return
            }
            if (this.captcha) {
                this.captcha.showCaptcha();
            } else {
                this.$message.error('验证码实例未准备好');
            }
        },
        // 开始倒计时
        startCountDown(result) {
            var data = result
            data.mobile = this.mobile
            sendcode(data).then(res => {
                // console.log(res)
                this.countDown = 60; // 设置倒计时为60秒
                const timer = setInterval(() => {
                    this.countDown--;
                    if (this.countDown <= 0) {
                        clearInterval(timer);
                    }
                }, 1000);
            });
        },
        submit() {
            const regex = /^1[3-9]\d{9}$/;
            if (!regex.test(this.mobile)) {
                this.$message('请输入正确的手机号！');
                return
            }
            if (!this.code) {
                this.$message('验证码不能为空');
                return
            }
            let data = {
                mobile: this.mobile,
                check_code: this.code
            }
            pepolist(data).then(res => {
                // console.log(res)
                sessionStorage.setItem("liuyanToken", res);
                this.getlist()
            }).catch(err => {
                console.error(err);
            });;
        },
        getlist() {
            this.$router.replace({
                name: "departedList",
                query: {}
            });
        },
    },
    created() {
        
    },
    beforeDestroy() {

    }
};
</script>
<style lang="less" scoped>
.page {
    width: 100%;
    height: 100vh;

    .imagebg {
        width: 100vw;
        height: 100vh;
    }

    .logo {
        position: absolute;
        width: 15%;
        top: 5px;
        left: 50%;
        transform: translateX(-50%);
    }


    .content {
        position: absolute;
        background: url('https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imagesNew/bg2.png');
        background-size: 100% 100%;
        width: 1050px;
        height: 722px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -45%);

        .mian {
            padding-top: 160px;
            padding-left: 192px;

            .wz {
                font-size: 34px;
                font-weight: bold;
                color: rgba(145, 255, 248, 1);
            }

            .inpm {
                margin-top: 30px;
                width: 680px;
                border: 2px solid rgba(145, 255, 248, 1);
                padding: 10px 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                input {
                    height: 60px;
                    border-radius: 10px;
                    background: rgba(0, 0, 0, 0);
                    font-size: 32px;
                    font-weight: bold;
                    color: rgba(145, 255, 248, 1);
                    border: none;
                }

                .yamanniu {
                    height: 60px;
                    text-align: center;
                    line-height: 60px;
                    font-size: 32px;
                    font-weight: bold;
                    color: rgba(145, 255, 248, 1);
                    cursor: pointer;
                }
            }
        }



        .aniu {
            margin: 0 auto;
            margin-top: 50px;
            width: 305px;
            height: 76px;
            border-radius: 10px;
            background: rgba(5, 255, 238, 1);
            font-size: 36px;
            color: #000;
            text-align: center;
            line-height: 76px;
            font-weight: bold;
            cursor: pointer;
        }
    }

    .tabm {
        position: absolute;
        width: 1050px;
        height: 722px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -45%);
        overflow-y: auto;

        .list {
            width: 100%;
            color: rgba(5, 255, 238, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 61px;
            border-left: 4px solid #09DDF3;
            border-right: 4px solid #09DDF3;
            margin-bottom: 30px;

            .list_l {
                font-size: 36px;
                display: flex;
                align-items: center;

                .avater {
                    padding-right: 25px;

                    img {
                        width: 92px;
                        height: 92px;
                        border-radius: 50%;
                    }
                }

                .suzi {
                    color: #fff;

                    .wz1 {
                        font-size: 30px;
                        transform: skewX(-5deg);
                    }

                    .wz2 {
                        font-size: 20px;
                        padding-top: 14px;
                        transform: skewX(-5deg);
                    }

                    .wz3 {
                        font-size: 18px;
                        padding-top: 14px;
                    }
                }
            }

            .list_r {
                cursor: pointer;
                width: 160px;
                height: 70px;
                font-size: 28px;
                border-radius: 5px;
                background: linear-gradient(180deg, #05FFEE 0%, #05FFEE 100%);
                box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.1);
                text-align: center;
                line-height: 70px;
                color: #000000;
                font-weight: bold;
                font-size: 26px;
            }
        }
    }

}
</style>